import { instanceAuth } from "api/apiConfig"

export const scholarshipFetchAPI = async data => {
  try {
    const response = await instanceAuth.get("Finance/GetAllScholarshipData", {
      params: {
        ...data,
      },
    })
    return response
  } catch (error) {
    console.log("error fetching scholarship data...", error)
    throw error
  }
}

export const scholarshipCreateAPI = async data => {
  try {
    const response = await instanceAuth.post(
      "Finance/RegisterNewScholarshipData",
      data,
    )
    return response
  } catch (error) {
    console.log("error creating scholarship...", error)
    throw error
  }
}

export const scholarshipUpdateAPI = async ({ id: id, data: data }) => {
  try {
    const response = await instanceAuth.put(
      `Finance/UpdateScholarshipDataById/${id}`,
      data,
    )
    return response
  } catch (error) {
    console.log("error updating scholarship...", error)
    throw error
  }
}

export const scholarshipDeleteAPI = async id => {
  try {
    const response = await instanceAuth.delete(
      `Finance/DeleteScholarshipDataById/${id}`,
    )
    return response
  } catch (error) {
    console.log("error deleting scholarship...", error)
    throw error
  }
}

export const scholarshipByIdAPI = async id => {
  try {
    const response = await instanceAuth.get(
      `Finance/GetAllScholarshipDataById/${id}`,
    )
    return response
  } catch (error) {
    console.log("error fetching scholarship by id...", error)
    throw error
  }
}

// Fetch a student's scholarship (used by the embedded Scholarship Details edit).
export const scholarshipByStudentIdAPI = async studentId => {
  try {
    const response = await instanceAuth.get(
      `Finance/GetScholarshipDataByStudentId/${studentId}`,
    )
    return response
  } catch (error) {
    console.log("error fetching scholarship by student id...", error)
    throw error
  }
}

// Applications list used to populate the Application ID dropdown in the form.
export const applicationDataForFinanceAPI = async data => {
  try {
    const response = await instanceAuth.get(
      "StudentApplication/ApplicationDataForFinance",
      {
        params: {
          ...data,
        },
      },
    )
    return response
  } catch (error) {
    console.log("error fetching application data for finance...", error)
    throw error
  }
}
